import {
  CompanyFactKey,
  CompanyFactSchemaVersion,
  ConflictStrategy,
  type FactKeyConfig,
} from '../core'

export enum ClockInMethodOption {
  /** @deprecated legacy value, retained so existing rows parse; pending remap to the new list. */
  TRABA_APP = 'TRABA_APP',
  /** @deprecated legacy value, retained so existing rows parse; pending remap to the new list. */
  TRABA_KIOSK = 'TRABA_KIOSK',
  /** @deprecated legacy value, retained so existing rows parse; pending remap to the new list. */
  INTERNAL_SYSTEM = 'INTERNAL_SYSTEM',
  INTERNAL_TRABA_KIOSK = 'INTERNAL_TRABA_KIOSK',
  CODES = 'CODES',
  EXTERNAL_TIMEKEEPING = 'EXTERNAL_TIMEKEEPING',
  PHYSICAL_TIMESHEETS = 'PHYSICAL_TIMESHEETS',
  THIRD_PARTY_TRABA_KIOSK = 'THIRD_PARTY_TRABA_KIOSK',
}

export enum TimesheetScheduleDay {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
}

export enum TimesheetScheduleTime {
  MORNING = 'MORNING',
  AFTERNOON = 'AFTERNOON',
}

export const TIMEKEEPING_KEY_CONFIG: Partial<
  Record<CompanyFactKey, FactKeyConfig>
> = {
  [CompanyFactKey.TIMEKEEPING_CLOCK_IN_METHOD]: {
    schemaVersion: CompanyFactSchemaVersion.SINGLE_SELECT_WITH_NOTES_V1,
    displayName: 'Timekeeping Method',
    options: Object.values(ClockInMethodOption),
  },
  [CompanyFactKey.TIMEKEEPING_TIMESHEET_EMAIL]: {
    schemaVersion: CompanyFactSchemaVersion.EMAIL_V1,
    displayName: 'Timesheet Email',
    conflictStrategy: ConflictStrategy.ALLOW_MULTIPLE,
  },
  [CompanyFactKey.TIMEKEEPING_TIMESHEET_SCHEDULE]: {
    schemaVersion: CompanyFactSchemaVersion.TIMESHEET_SCHEDULE_V1,
    displayName: 'Timesheet Schedule',
    conflictStrategy: ConflictStrategy.ALLOW_MULTIPLE,
  },
  [CompanyFactKey.TIMEKEEPING_TIME_DISPUTE_PROCESS]: {
    schemaVersion: CompanyFactSchemaVersion.TEXT_V3,
    displayName: 'Time Dispute Process',
    conflictStrategy: ConflictStrategy.APPEND,
    purposeTooltip:
      'Procedure a worker follows when they dispute their recorded clock-in/out times (e.g., "contact supervisor within 24 hours, supervisor adjusts in kiosk"). Captures the per-company correction workflow.',
  },
  [CompanyFactKey.TIMEKEEPING_NOTES]: {
    schemaVersion: CompanyFactSchemaVersion.TEXT_V3,
    displayName: 'Notes',
    conflictStrategy: ConflictStrategy.APPEND,
  },
}
